import React from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { isLoggedIn } from "../../helpers/user";

import styles from "./index.module.scss";

const LandingHero = () => {
  const navigate = useNavigate();
  const enterBtnText = isLoggedIn() ? "До гри" : "Увійти";

  return (
    <main className={styles.landing} id="home" tabIndex="-1">
      <section className={styles.hero}>
        <div className={styles.heroMedia} aria-hidden="true" />
        <div className={styles.heroOverlay} />
        <div className={styles.heroContent}>
          <div className={styles.copy}>
            <p className={styles.eyebrow}>🇺🇦 Перша ліга Україна</p>
            <h1 className={styles.head}>
              <img className={styles.logo} src="/soccer-circle.svg" alt="" />
              <div>
                <div>ФЕНТЕЗІ</div>
                <div>ПЕРША</div>
              </div>
            </h1>
            <p className={styles.lead}>
              Створи команду з реальних футболістів, слідкуй за матчами та
              набирай очки за дії твоїх гравців на футбольному полі. Відчуй себе
              справжнім тренером!
            </p>
            <div className={styles.actions}>
              <Button
                onClick={() => navigate("/home")}
                size="lg"
                className={styles.primaryAction}
                variant="primary"
              >
                <i className="bi bi-box-arrow-in-right"></i>
                <span>{enterBtnText}</span>
              </Button>
              <Button
                onClick={() => navigate("/rules")}
                size="lg"
                className={styles.secondaryAction}
                variant="outline-light"
              >
                <i className="bi bi-file-ruled"></i>
                <span>Правила</span>
              </Button>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default LandingHero;
